/**
 * Числа внутри переведённых строк (`#` в plural, `{n, number}`) форматирует
 * FormatJS локалью интерфейса. У Chrome урезанный ICU без данных `uz`: для
 * «uz-Latn» он молча берёт английский шаблон и печатает «90,607» — запятая,
 * которую узбекский читатель видит как десятичную (экранная вычитка 08.10).
 * Узбекский CLDR пишет числа как русский — разряды неразрывным пробелом,
 * дробь запятой, — поэтому `uz*` здесь форматируется шаблоном `ru-RU`, тем же,
 * что у `numberLocale()` (журнал №1114). Остальные локали не трогаются.
 */
const UZ = /^uz(?:-|$)/i;

function mapLocale(locale: string): string {
  return UZ.test(locale) ? 'ru-RU' : locale;
}

export function mapNumberLocales(locales: string | readonly string[] | undefined): string | string[] | undefined {
  if (locales === undefined) return undefined;
  return typeof locales === 'string' ? mapLocale(locales) : locales.map(mapLocale);
}

let installed = false;

/** Подменить `Intl.NumberFormat` один раз до первого форматирования. */
export function installUzNumberFormat(): void {
  if (installed) return;
  installed = true;
  const Native = Intl.NumberFormat;
  const Patched = function NumberFormat(locales?: string | readonly string[], options?: Intl.NumberFormatOptions) {
    return new Native(mapNumberLocales(locales), options);
  } as unknown as typeof Intl.NumberFormat;
  Object.defineProperty(Patched, 'prototype', { value: Native.prototype });
  Object.defineProperty(Patched, 'supportedLocalesOf', { value: Native.supportedLocalesOf.bind(Native) });
  Intl.NumberFormat = Patched;
}
